import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Title from '../../commonComponents/Title';
import SignInContainer from '../signIn/container/SignInContainer';
import Notifications from '../../services/notifications';
import SignUpForm from './SignUpForm';
import translate from '../../commonComponents/translate';
import TenantProp from '../../commonComponents/propTypes/tenantProp';
import CountryProp from '../../commonComponents/forms/Address/CountryProp';
import CurrencyProp from '../profile/propTypes/currencyProp';
import { compose } from '../../services/utilityFunctions';

function SignUp(props) {
  const {
    t,
    theme,
    logo,
    languages,
    tenant,
    organizationIdentifier,
    availableCountries,
    availableCurrencies,
  } = props;

  const countries = availableCountries.map(country => ({
    id: country.code,
    text: country.name,
  }));
  const currencies = availableCurrencies.map(currency => ({
    id: currency.code,
    text: currency.name,
  }));

  const onCompleteSignUp = useCallback(() => {
    Notifications.showNotificationSuccess(
      t('success'),
      t('user.successfully.registered'),
    );
    window.location.href = '/signin';
  }, [t]);

  return (
    <Title title={t('signup_head_title')}>
      <div
        className="m-grid m-grid--hor m-grid--root m-page"
        style={{ height: '100vh' }}
      >
        <SignInContainer theme={theme} logo={logo}>
          <SignUpForm
            languages={languages}
            onComplete={onCompleteSignUp}
            tenant={tenant}
            organizationIdentifier={organizationIdentifier}
            buttonTxt={t('login_createAccount')}
            countries={countries}
            currencies={currencies}
          />
        </SignInContainer>
      </div>
    </Title>
  );
}

SignUp.propTypes = {
  t: PropTypes.func.isRequired,
  logo: PropTypes.string,
  tenant: PropTypes.shape(TenantProp.propType).isRequired,
  languages: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType))
    .isRequired,
  availableCountries: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType))
    .isRequired,
  availableCurrencies: PropTypes.arrayOf(PropTypes.shape(CurrencyProp.propType))
    .isRequired,
  organizationIdentifier: PropTypes.string.isRequired,
};

SignUp.defaultProps = {
  logo: null,
};

export default compose(translate)(SignUp);
